import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  withStyles,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button
} from "@material-ui/core";

import * as statisticsReducers from '../reducer';
import * as statisticsActionMgr from '../action-mgr';
import * as strings from '../../helpers/strings';
import '../../index.css';
import StationSelect from './StationStatisticsSelect';
import StationBiDirectionalSelect from './StationBiDirectionalSelect';

import { months } from '../../helpers/constants';

const styles = {
  formControlWrapper: { marginBottom: 15 },
  formControlWrapperSelectMenu: {
    '& > div > div': {
      boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)' 
    }
  },
  rangeSelection: {
    width: "100px"
  },
  formControlCheckboxWrapper: { width: '100%', marginBottom: 15, padding: '15px', border: '1px solid #0000003d', borderRadius: '5px', boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)'},
  CheckboxFormLabelBiDirectional: { textAlign: 'left', padding: '0px 2px', fontSize: '13px', width: '95px' }
};


// Helper function to get all months and mark availability
const getMonths = (availableMonths) => {
  if (!availableMonths || availableMonths.length === 0) return [];

  // Map availableMonths (like "2024-01") into ["01", "02", etc.]
  const availableMonthValues = availableMonths.map((month) => month.split("-")[1]);

  // Use the imported months list, format the value properly ("01", "02", etc.)
  return months.map((month) => ({
    name: month.name,
    value: month.value.toString().padStart(2, "0"), // Convert 1 → "01", 2 → "02", etc.
    available: availableMonthValues.includes(month.value.toString().padStart(2, "0")),
  }));
};

// Helper function to get the number of days in a given month
const getDaysInMonth = (year, month) => {
  if (month < 1 || month > 12 || isNaN(year) || isNaN(month)) {
    console.error(`Invalid year (${year}) or month (${month}) passed to getDaysInMonth`);
    return 0; // Return 0 if the inputs are invalid
  }
  return new Date(year, month, 0).getDate(); // Get the last day of the month
};

class StationStatisticsFormBiDirectionalEnergy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isStationSwitching: false,
      hasFetchedForCurrentFilter: false,
      selectAllBidirectionalMeters: false,
      availableYears: [],
      availableMonths: [],
      availableDays: [],
      downloadButtonDisabled: true,
    };
  }

  componentDidMount() {
    const { selectedBiDirectionalStation, callBiDirectionalMeter, callBiDirectionalEnergyDataDates, callStatisticsTotalize } = this.props;
  
    if (selectedBiDirectionalStation) {
      callStatisticsTotalize(selectedBiDirectionalStation);

      callBiDirectionalMeter(selectedBiDirectionalStation)
        .then((biDirectionalMeterList) => {
          if (biDirectionalMeterList && biDirectionalMeterList.facilities && biDirectionalMeterList.facilities.length > 0) {
            // If the station has bi-directional meters, fetch the available dates
            callBiDirectionalEnergyDataDates({ stationName: selectedBiDirectionalStation });
            this.setState({ selectAllBidirectionalMeters: true });
          }
        })
        .catch(error => {
          console.error("Error fetching bi-directional meters:", error);
        });
    }
  }

  async componentDidUpdate(prevProps) {
    const {
      selectedBiDirectionalStation,
      callBiDirectionalMeter,
      biDirectionalMeterList,
      biDirectionalEnergyDataDates,
      callBiDirectionalEnergyDataDates,
      callBiDirectionalEnergyData,
      selectedYear,
      selectedMonth,
      selectedDay,
      selectedView,
      biDirectionalEnergyFilter,
      resetBiDirectionalData,
      updateBiDirectionalEnergyFilter,
      callStatisticsTotalize,
      resetBiDirectionalMeterList
    } = this.props;
  
    const selectedTime = biDirectionalEnergyFilter.time;
    const selectedFacilities = biDirectionalEnergyFilter.facilities;
   
    if (prevProps.selectedBiDirectionalStation !== selectedBiDirectionalStation) {
      callStatisticsTotalize(selectedBiDirectionalStation);
      this.setState({ isStationSwitching: true, selectAllBidirectionalMeters: false });
    
      try {
        const meterData = await callBiDirectionalMeter(selectedBiDirectionalStation);
    
        if (meterData && meterData.facilities && meterData.facilities.length > 0) {
          await callBiDirectionalEnergyDataDates({ stationName: selectedBiDirectionalStation });
    
          updateBiDirectionalEnergyFilter({
            facilities: meterData.facilities,
            type: 'all',
            time: '',
          });
    
          this.setState({ selectAllBidirectionalMeters: true });
    
          // Fetch energy data immediately after setting facilities
          this.fetchBiDirectionalEnergyData(); 
        } else {

          updateBiDirectionalEnergyFilter({
            facilities: [],
            type: 'all',
            time: '',
          });
          resetBiDirectionalMeterList();
          resetBiDirectionalData();
        }
      } catch (error) {
        console.error("Error fetching meters or dates:", error);
        resetBiDirectionalData();
      }
    
      this.setState({ isStationSwitching: false });
      this.fetchBiDirectionalEnergyData(); 

      return;
    }
    
    
    // Check if facilities have changed
    if (prevProps.biDirectionalEnergyFilter.facilities !== selectedFacilities) {
      const hasSelectedFacilities = selectedFacilities.length > 0;
      this.setState({ downloadButtonDisabled: !hasSelectedFacilities });
    }
    // This block handles the case where facilities list becomes empty:
    if (
      prevProps.biDirectionalEnergyFilter.facilities.length > 0 &&
      selectedFacilities.length === 0
    ) {
      resetBiDirectionalData();
    }

    if (
      prevProps.selectedView !== selectedView ||
      prevProps.selectedMonth !== selectedMonth ||
      prevProps.selectedYear !== selectedYear ||
      prevProps.selectedDay !== selectedDay || 
      prevProps.biDirectionalEnergyFilter !== biDirectionalEnergyFilter
    ) {
      resetBiDirectionalData();
      this.fetchBiDirectionalEnergyData();
      this.setState({ hasFetchedForCurrentFilter: true });
    }
  
    // Available Dates Update
    if (prevProps.biDirectionalEnergyDataDates !== biDirectionalEnergyDataDates) {
      const { startYearList, startMonthList, startDayList } = biDirectionalEnergyDataDates.data || {};
      this.setState({
        availableYears: startYearList || [],
        availableMonths: startMonthList || this.state.availableMonths,
        availableDays: (["day", "half-hour"].includes(selectedView) && selectedMonth) ? startDayList || [] : [],
      });
    }
  
    // Month View Selection
    if (prevProps.selectedView !== selectedView && selectedView === "month" && selectedYear && this.state.availableMonths.length === 0) {
      callBiDirectionalEnergyDataDates({ stationName: selectedBiDirectionalStation, startYear: selectedYear });
    }
  
    // Day View Selection
    if (prevProps.selectedMonth !== selectedMonth && (selectedView === "day" || selectedView === "half-hour")) {
      if (selectedMonth && !this.state.availableDays.length) {
        const [year, month] = selectedMonth.split("-");
        callBiDirectionalEnergyDataDates({ stationName: selectedBiDirectionalStation, startYear: year, startMonth: parseInt(month) });
      }
    }
  
    // Trigger API Call for Bi-Directional Energy Data
    if (
      prevProps.selectedYear !== selectedYear ||
      prevProps.selectedMonth !== selectedMonth ||
      prevProps.selectedDay !== selectedDay ||
      prevProps.selectedView !== selectedView ||
      prevProps.biDirectionalEnergyFilter !== biDirectionalEnergyFilter
    ) {
      if (biDirectionalEnergyFilter.facilities.length > 0) {
        // Update time in the filter if necessary
        if (selectedView === "year" && selectedTime !== selectedYear) {
          updateBiDirectionalEnergyFilter({ time: selectedYear });
          resetBiDirectionalData();
        } else if (selectedView === "month" && selectedTime !== selectedMonth) {
          updateBiDirectionalEnergyFilter({ time: selectedMonth });
          resetBiDirectionalData();
        } else if ((selectedView === "day" || selectedView === "half-hour") && selectedTime !== selectedDay) {
          updateBiDirectionalEnergyFilter({ time: selectedDay });
          resetBiDirectionalData();
        }
      }
    }
  }
  
  componentWillUnmount() {
    const {
      resetBiDirectionalData,
      resetBiDirectionalMeterList,
      selectYear,
      selectMonth,
      selectDay,
      selectView,
      updateBiDirectionalEnergyFilter,
    } = this.props;
  
    // Reset Redux data
    resetBiDirectionalData();
    resetBiDirectionalMeterList();
  
    // Reset Redux UI filters
    selectView("all");
    selectYear("");
    selectMonth("");
    selectDay("");
    updateBiDirectionalEnergyFilter({ type: "all", facilities: [], time: "" });
  
    // Reset local state if needed
    this.setState({
      availableYears: [],
      availableMonths: [],
      availableDays: [],
      downloadButtonDisabled: true,
      selectAllBidirectionalMeters: false
    });
  }
  
  fetchBiDirectionalEnergyData = () => {

    if (this.state.isStationSwitching) return; // Prevent fetch during transition

    const {
      biDirectionalEnergyFilter,
      selectedBiDirectionalStation,
      callBiDirectionalEnergyData,
    } = this.props;
  
    let params = {
      station: selectedBiDirectionalStation,
      facilities: biDirectionalEnergyFilter.facilities,
      type: biDirectionalEnergyFilter.type,
      time: biDirectionalEnergyFilter.time || undefined,
    };
  
    // Call the API to fetch the new data
    callBiDirectionalEnergyData(params);
  };
  

  handleSelectRange = (event) => {
    const selectedView = event.target.value;
  
    if (this.props.selectedView === selectedView) {
      // Same view reselected — refresh the data
      this.props.resetBiDirectionalData();
      this.fetchBiDirectionalEnergyData();
    } else {
      this.props.selectView(selectedView);
      this.props.updateBiDirectionalEnergyFilter({ type: selectedView, time: '' });
      this.props.selectYear('');
      this.props.selectMonth('');
      this.props.selectDay('');
      this.setState({
        availableMonths: [],
        availableDays: [],
      });
    }
  };  
  
  handleSelectYear = (event) => {
    const selectedYear = event.target.value;
    if (this.props.selectedYear === selectedYear) {
      this.props.resetBiDirectionalData(); // Clear chart
      this.fetchBiDirectionalEnergyData(); // Re-fetch data for the same year
    } else {
      this.props.selectYear(selectedYear);
      this.props.updateBiDirectionalEnergyFilter({ time: selectedYear });
    }

    if (["month", "day", "half-hour"].includes(this.props.selectedView)) {
      this.props.callBiDirectionalEnergyDataDates({ stationName: this.props.selectedBiDirectionalStation, startYear: selectedYear });
      this.props.selectMonth('');
      this.props.selectDay('');
      this.setState({
        availableMonths: [],
        availableDays: [],
      });
    }
  };

  handleSelectMonth = (event) => {
    const selectedMonth = event.target.value;
    if (this.props.selectedMonth === selectedMonth) {
      this.props.resetBiDirectionalData();
      this.fetchBiDirectionalEnergyData();
    } else {
      this.props.selectMonth(selectedMonth);
      this.props.updateBiDirectionalEnergyFilter({ time: selectedMonth });
    }
    if (this.props.selectedView === 'day' || this.props.selectedView === 'half-hour') {
      const [year, month] = selectedMonth.split('-');
      this.props.callBiDirectionalEnergyDataDates({ stationName: this.props.selectedBiDirectionalStation, startYear: year, startMonth: parseInt(month) });
      this.props.selectDay('');
      this.setState({
        availableDays: [],
      });
    }
  };
  
  handleSelectDay = (event) => {
    const selectedDay = event.target.value;
    const { selectedView } = this.props;

    // If the same day is selected again, refresh data
    if (this.props.selectedDay === selectedDay) {
      this.props.resetBiDirectionalData();
      this.fetchBiDirectionalEnergyData();
    } else {
      // Always update the selected day
      this.props.selectDay(selectedDay);

      // If the view is "day" or "half-hour", update the filter time
      if (selectedView === "day" || selectedView === "half-hour") {
        this.props.updateBiDirectionalEnergyFilter({ time: selectedDay });
      }
    }
  };


  handleSelectBidirectionalField = (event) => {
    const { biDirectionalMeterList, biDirectionalEnergyFilter, selectBiDirectionalFacility, updateBiDirectionalEnergyFilter } = this.props;
    const meter = event.target.value;
    const currentFacilities = biDirectionalEnergyFilter.facilities || [];

    let updatedFacilities = [];
    if (currentFacilities.includes(meter)) {
        updatedFacilities = currentFacilities.filter(f => f !== meter);
    } else {
        updatedFacilities = [...currentFacilities, meter];
    }

    // console.log("Updated Facilities View: ", updatedFacilities);  // Log the updated facilities

    selectBiDirectionalFacility(updatedFacilities);
    updateBiDirectionalEnergyFilter({ facilities: updatedFacilities });

    const allSelected = biDirectionalMeterList.facilities.length === updatedFacilities.length;
    this.setState({ selectAllBidirectionalMeters: allSelected });
  };

  
  handleSelectAllBidirectionalMeters = () => {
    const { biDirectionalMeterList, selectBiDirectionalFacility, updateBiDirectionalEnergyFilter } = this.props;
    const { selectAllBidirectionalMeters } = this.state;

    const allFacilities = biDirectionalMeterList.facilities;

    if (selectAllBidirectionalMeters) {
      // Deselect all
      selectBiDirectionalFacility([]);
      updateBiDirectionalEnergyFilter({ facilities: [] });
    } else {
      // Select all
      selectBiDirectionalFacility(allFacilities);
      updateBiDirectionalEnergyFilter({ facilities: allFacilities });
    }

    // Toggle the selectAllBidirectionalMeters state
    this.setState({ selectAllBidirectionalMeters: !selectAllBidirectionalMeters });
  };

  handleDownloadClick = () => {

    console.log("handleDownloadClick click");
    const { biDirectionalEnergyData, selectedBiDirectionalStation, biDirectionalEnergyFilter, statisticsTotalize } = this.props;

    if (!biDirectionalEnergyData || biDirectionalEnergyData.length === 0) {
        // No data to download
        console.log("No data to download");
        return;
    }

    const selectedView = biDirectionalEnergyFilter.type;
    const time = biDirectionalEnergyFilter.time;    

    // Create headers dynamically based on facilities
    const facilities = [...new Set(biDirectionalEnergyData.map(data => data.facility))];
    facilities.sort();

    // Define dynamic headers for CSV
    const dynamicHeaders = ['Time'];
    facilities.forEach(facility => {
        dynamicHeaders.push(`${facility} Grid Consumption Import (kWh)`);
        dynamicHeaders.push(`${facility} Energy Export (kWh)`);
        dynamicHeaders.push(`${facility} Solar Consumption (kWh)`);
        dynamicHeaders.push(`${facility} Building Consumption (kWh)`);
    });

    // Prepare the data rows for CSV
    const facilityData = [];
    const timeData = [...new Set(biDirectionalEnergyData.map(data => data.time))];

    timeData.forEach(time => {
        const rowData = [time]; // First column is time

        facilities.forEach(facility => {
            const data = biDirectionalEnergyData.find(d => d.facility === facility && d.time === time);
            rowData.push(data ? data.energyImport : 'NA');
            rowData.push(data ? data.energyExport : 'NA');
            rowData.push(data ? data.solarGen : 'NA');
            rowData.push(data ? data.buildingConsumption : 'NA');
        });

        facilityData.push(rowData);
    });

    // Convert the data into CSV format
    const csvRows = [];
    csvRows.push(dynamicHeaders.join(','));
    facilityData.forEach(data => csvRows.push(data.join(',')));

    const csvData = '\uFEFF' + csvRows.join('\n');
    // Generate the filename with time if available
    const timeSuffix = time ? `_${time}` : '';
    const filename = `${selectedBiDirectionalStation}_BiDirectional_${selectedView}${timeSuffix}.csv`;

    // Create a blob and download the CSV file
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();

    URL.revokeObjectURL(url);
  };

  render() {
    const { classes, selectedView, selectedYear, selectedMonth, selectedDay, biDirectionalMeterList, biDirectionalEnergyFilter } = this.props;
    const { availableYears, availableMonths, availableDays, selectAllBidirectionalMeters } = this.state;
    const hasBiDirectionalMeters = biDirectionalMeterList && biDirectionalMeterList.facilities && biDirectionalMeterList.facilities.length > 0;

    // Get all months for the selected year
    const months = getMonths(availableMonths);

    // Get all days for the selected month
    const totalDaysInMonth = selectedYear && selectedMonth && selectedMonth.includes('-') 
    ? getDaysInMonth(selectedYear, parseInt(selectedMonth.split('-')[1])) 
    : 31;
    const allDays = Array.from({ length: totalDaysInMonth }, (_, i) => i + 1).map(day => day.toString().padStart(2, '0'));


    return (
      <Grid container alignItems="center">
        <StationBiDirectionalSelect />
        {hasBiDirectionalMeters && (
        <>
          <Grid item xs={12}>
            <FormControl className={classes.formControlWrapper} variant={strings.txtOutlined} fullWidth={true}>
              <InputLabel htmlFor={strings.idSelectRange} className={classes.rangeSelection}>
                {strings.lblDisplayMode}
              </InputLabel>
              <Select
                value={selectedView}
                onChange={this.handleSelectRange}
                input={
                  <OutlinedInput
                    labelWidth={100}
                    name={strings.lblRange}
                    id={strings.idSelectRange}
                    className={classes.formControlWrapperSelectMenu} // Consistent class
                  />
                }
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="year">Year</MenuItem>
                <MenuItem value="month">Month</MenuItem>
                <MenuItem value="day">Day</MenuItem>
                <MenuItem value="half-hour">Half Hour</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </>
        )}
        {/* Existing display mode and date selection code */}

  
        {/* Year Selection */}
        {(selectedView === "year" || selectedView === "month" || selectedView === "day" || selectedView === "half-hour") && (
          <Grid item xs={12}>
            <FormControl className={classes.formControlWrapper} variant={strings.txtOutlined} fullWidth={true}>
              <InputLabel htmlFor="year-select">{strings.lblYear}</InputLabel>
              <Select
                value={selectedYear}
                onChange={this.handleSelectYear}
                input={
                  <OutlinedInput
                    labelWidth={60}
                    name="Year"
                    id="year-select"
                    className={classes.formControlWrapperSelectMenu}
                  />
                }
              >
                {availableYears.map(year => (
                  <MenuItem key={year} value={year}>{year}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
  
        {/* Month Selection */}
        {(selectedView === "month" || selectedView === "day" || selectedView === "half-hour") && selectedYear && (
          <Grid item xs={12}>
            <FormControl className={classes.formControlWrapper} variant={strings.txtOutlined} fullWidth={true}>
              <InputLabel htmlFor="month-select">{strings.lblMonth}</InputLabel>
              <Select
                value={selectedMonth}
                onChange={this.handleSelectMonth}
                input={
                  <OutlinedInput
                    labelWidth={60}
                    name="Month"
                    id="month-select"
                    className={classes.formControlWrapperSelectMenu}
                  />
                }
              >
                {months.map(({ name, value, available }) => (
                  <MenuItem key={value} value={`${selectedYear}-${value}`} disabled={!available}>
                    {name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
  
        {/* Day Selection */}
        {(selectedView === "day" || selectedView === "half-hour") && selectedMonth && (
          <Grid item xs={12}>
            <FormControl className={classes.formControlWrapper} variant={strings.txtOutlined} fullWidth={true}>
              <InputLabel htmlFor="day-select">{strings.lblDay}</InputLabel>
              <Select
                value={selectedDay || ""}
                onChange={this.handleSelectDay}
                input={
                  <OutlinedInput
                    labelWidth={60}
                    name="Day"
                    id="day-select"
                    className={classes.formControlWrapperSelectMenu}
                  />
                }
              >
                {allDays.map(day => {
                  const fullDay = `${selectedYear}-${selectedMonth.split('-')[1]}-${day}`;
                  const isAvailable = availableDays.includes(fullDay);
                  return (
                    <MenuItem key={day} value={fullDay} disabled={!isAvailable}>
                      {day}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
        )}
  
        {/* Bi-Directional Meters Checkboxes */}
        {biDirectionalMeterList && biDirectionalMeterList.facilities && biDirectionalMeterList.facilities.length > 0 && (
          <Grid item xs={12}>
            <FormControl component="fieldset" className={classes.formControlCheckboxWrapper}>
              <FormLabel component="legend" className={classes.CheckboxFormLabelBiDirectional}>Bi Directional Meters</FormLabel>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      value="selectAllBidirectional"
                      color={strings.colorPrimary}
                      checked={selectAllBidirectionalMeters}
                      onChange={this.handleSelectAllBidirectionalMeters}
                    />
                  }
                  label="All"
                />
                {biDirectionalMeterList.facilities.map(meter => (
                  <FormControlLabel
                    key={meter}
                    control={
                      <Checkbox
                        value={meter}
                        color={strings.colorPrimary}
                        checked={biDirectionalEnergyFilter.facilities.includes(meter)}
                        onChange={this.handleSelectBidirectionalField}
                      />
                    }
                    label={meter}
                  />
                ))}
              </FormGroup>
            </FormControl>
          </Grid>
        )}
        <Grid item xs={12} container justify="flex-start">
            <Button
              variant="contained"
              color={strings.colorPrimary}
              size="medium"
              style={{ opacity: this.state.downloadButtonDisabled ? 0.5 : 1 }}
              disabled={this.state.downloadButtonDisabled}
              onClick={this.handleDownloadClick}
            >
              Download
            </Button>
          </Grid>           
      </Grid>
    );
  }  
}

const mapStateToProps = state => ({
  selectedBiDirectionalStation: statisticsReducers.getSelectedBiDirectionalStation(state),
 
  biDirectionalEnergyDataDates: statisticsReducers.getBiDirectionalEnergyDataDates(state), // Dates data
  biDirectionalMeterList: statisticsReducers.getBiDirectionalMeter(state),
  biDirectionalEnergyFilter: statisticsReducers.getBiDirectionalEnergyFilter(state),
  biDirectionalEnergyData: statisticsReducers.getBiDirectionalEnergyData(state),

  selectedView: statisticsReducers.getSelectedView(state),
  selectedDay: statisticsReducers.getSelectedDay(state),
  selectedMonth: statisticsReducers.getSelectedMonth(state),
  selectedYear: statisticsReducers.getSelectedYear(state),

});

const mapActionsToProps = {
  callBiDirectionalMeter: statisticsActionMgr.callBiDirectionalMeter,
  selectBiDirectionalFacility: statisticsActionMgr.selectBiDirectionalFacility,
  callBiDirectionalEnergyDataDates: statisticsActionMgr.callBiDirectionalEnergyDataDates,
  callBiDirectionalEnergyData: statisticsActionMgr.callBiDirectionalEnergyData,
  callStatisticsTotalize: statisticsActionMgr.callStatisticsTotalize,
  updateBiDirectionalEnergyFilter: statisticsActionMgr.updateBiDirectionalEnergyFilter,  
  resetBiDirectionalData: statisticsActionMgr.resetBiDirectionalData, 
  resetBiDirectionalMeterList: statisticsActionMgr.resetBiDirectionalMeterList,

  selectView: statisticsActionMgr.selectView,
  selectDay: statisticsActionMgr.selectDay,
  selectYear: statisticsActionMgr.selectYear,
  selectMonth: statisticsActionMgr.selectMonth,
};

export default connect(mapStateToProps, mapActionsToProps)(
  withStyles(styles)(StationStatisticsFormBiDirectionalEnergy)
);